export default __webpack_public_path__ + "static/press_4_orig-88dc40dc8be939c878394fd71314d6bc.jpg";